import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthService } from 'app/core/auth/auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const auth = inject(AuthService);

    // Check the authentication status
    return auth.check().pipe(
        map((authenticated: boolean) => {
            if (authenticated) return true;
            // If the user is not authenticated...
            // Prefer the explicit reason set by AuthService; fallback if ever null
            const reason = auth.lastFailReason ?? (auth.hasToken ? 'sessionExpired' : 'unauthorized');

            const queryParams: any = { reason };
            if (state.url !== '/sign-out') queryParams.redirectURL = state.url;

            return router.createUrlTree(['sign-in'], { queryParams });
        })
    );
};
